import { render, staticRenderFns } from "./LicenseCompare.vue?vue&type=template&id=d142b6d8&scoped=true&"
import script from "./LicenseCompare.vue?vue&type=script&lang=js&"
export * from "./LicenseCompare.vue?vue&type=script&lang=js&"
import style0 from "./LicenseCompare.vue?vue&type=style&index=0&id=d142b6d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d142b6d8",
  null
  
)

export default component.exports